import type {
    ComponentStageData,
    ComponentStageHandlerResults,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginHeuristicsRegistry,
    PluginStageHandler
} from '../../types'
import {heightHeuristics, verticalMarginsHeuristics} from './heuristicsDefinitions'
import {createAdaptiveHeuristic, findHeuristic} from '../common'

export const createPlugin = ({stages, readOnlyExtensionAPI}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const calculateMarginTop: PluginStageHandler<ComponentStageData> = (componentStageData: ComponentStageData) => {
        const heuristicToApply = findHeuristic(verticalMarginsHeuristics, componentStageData)
        heuristicToApply.apply(componentStageData)

        return {appliedHeuristics: [heuristicToApply.heuristicCode]}
    }

    const calculateHeight: PluginStageHandler<ComponentStageData> = (
        componentStageData: ComponentStageData
    ): ComponentStageHandlerResults => {
        const heuristicToApply = findHeuristic(heightHeuristics, componentStageData)
        heuristicToApply.apply(componentStageData, undefined, readOnlyExtensionAPI)

        return {appliedHeuristics: [heuristicToApply.heuristicCode]}
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.VERTICAL_LAYOUT_SCALE, createAdaptiveHeuristic(calculateHeight))
        registry.register(stages.VERTICAL_LAYOUT_SCALE, createAdaptiveHeuristic(calculateMarginTop))
    }

    const name = 'verticalScaleAndSize'
    return {register, name, dependencies: ['horizontalScaleAndSize']}
}
